import { ChangeEventHandler, forwardRef, InputHTMLAttributes, RefAttributes, useCallback } from "react";
import {
  roundedClassName,
  borderClassName,
  inputClassName,
  inputColorClassName,
  getFocusOutline,
} from "./commonClassNames";
import { BorderProps, InputColorProps, InputTextSizeProp } from "./commonProps";

export type TextareaProps = Omit<InputHTMLAttributes<HTMLTextAreaElement>, "className" | "onChange" | "height"> &
  RefAttributes<HTMLTextAreaElement> &
  BorderProps &
  InputColorProps &
  InputTextSizeProp & {
    setValue?: (value: string) => void;
    height?: 12 | 24 | 32 | 40;
  };

export const Textarea: React.FC<TextareaProps> = forwardRef(
  ({ border, grouped, neutral, setValue, height, transparent, ...props }, ref) => {
    const className = [
      roundedClassName({ grouped }),
      borderClassName({ border }),
      inputClassName(),
      inputColorClassName({ transparent, neutral }),
      `h-${height ?? 24} py-2 px-3 text-base`,
      getFocusOutline({ border }),
    ].join(" ");

    const onChange = useCallback<ChangeEventHandler<HTMLTextAreaElement>>(
      (event) => {
        const value = event.target.value;
        setValue?.(value);
      },
      [setValue],
    );

    return <textarea className={className} onChange={onChange} {...props} ref={ref} />;
  },
);
